<template>
  <div id="document-export-container">
    <div ref="exportable" class="pdf-export">
      <div class="frontpage">
        <img v-if="frontpage" :src="frontpage" alt="" />
        <div v-else class="placeholder" />
      </div>
      <div class="reportTitle">
        SAV-Bericht vom {{ exportDate }}
      </div>
      <template v-for="(section, sdx) in computedData">
        <div class="section" :key="`section-${sdx}`" :class="{ first: isFirstOfPage(`${sdx}-0`) }">
          <template v-if="section.type && section.type === 'privacy'">
            <img class="privacy" :class="{ pad: isSmallFrontpage }" :src="section.imgData" alt="">
            <div v-if="isPageBreak(`${sdx}-0`)" class="page-break" />
          </template>
          <template v-else>
            <div class="group" v-for="(group, gdx) in section.groups" :class="{ first: isFirstOfPage(`${sdx}-${gdx}`) }" :key="`section-${sdx}-group-${gdx}`">
              <!-- <span>{{ `${sdx}-${gdx}` }}</span> -->
              <div v-if="showTitle(`${sdx}-${gdx}`)" class="section-title">{{ section.heading }}</div>
              <template v-if="group.type === 'icf'">
                <div class="icf-content">
                  <div class="legend">
                    <template v-if="showICFLegend(`${sdx}-${gdx}`)">
                      <strong>1</strong> = kein Problem / Ressource,
                      <strong>2</strong> = Problem leicht-mässig,
                      <strong>3</strong> = Problem erheblich-voll,
                      <strong>*</strong> = k.A., nicht spezif., nicht anwendb.
                    </template>
                  </div>
                  <template v-if="group.inputs.length === 3">
                    <div class="content">
                      <div class="left">
                        <strong>{{ group.label }}</strong>
                        <div class="assessment" v-html="getAssessmentValue(group.inputs[0].value, group.inputs[0].fallback)" />
                      </div>
                      <div class="right">
                        <table>
                          <tr>
                            <td></td>
                            <td>1</td>
                            <td>2</td>
                            <td>3</td>
                            <td>*</td>
                          </tr>
                          <tr v-for="(item, vdx) in (group.inputs[1] || {}).value || []" :key="`section-${sdx}-}group-${gdx}-matrix-${vdx}`">
                            <td>{{ item.code ? `(${item.code}) ` : ''}}{{ item.label }}</td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(1, item.value) }" /></td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(2, item.value) }" /></td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(3, item.value) }" /></td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(4, item.value) }" /></td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="comment">
                      {{ (group.inputs[2] || {}).value || '' }}
                    </div>
                  </template>
                  <template v-else-if="group.inputs.length === 2">
                    <div class="content">
                      <div class="left">
                        <strong>{{ group.label }}</strong>
                        <div class="assessment">(kein Indikationsbereich)</div>
                      </div>
                      <div class="right">
                        <table>
                          <tr>
                            <td></td>
                            <td>1</td>
                            <td>2</td>
                            <td>3</td>
                            <td>*</td>
                          </tr>
                          <tr v-for="(item, vdx) in (group.inputs[0] || {}).value || []" :key="`section-${sdx}-}group-${gdx}-matrix-${vdx}`">
                            <td>{{ item.label }}</td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(1, item.value) }" /></td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(2, item.value) }" /></td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(3, item.value) }" /></td>
                            <td><span :class="{ radio: true, checked: isActiveMatrixValue(4, item.value) }" /></td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="comment">
                      {{ (group.inputs[1] || {}).value || '' }}
                    </div>
                  </template>
                </div>
              </template>

              <template v-else-if="group.type === 'radio-matrix-advanced'">
                <div class="matrix-advanced-content">
                  <table>
                    <tr>
                      <td></td>
                      <td colspan="2">Aktuell</td>
                      <td colspan="2">Anvisiert (1-2 Jahre)</td>
                      <td rowspan="2">Schwerpunkt<br/> für<br/> Förderung</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Alters- /<br/> Lehrplangemäss</td>
                      <td>Individualisiert</td>
                      <td>Alters- /<br/> Lehrplangemäss</td>
                      <td>Individualisiert</td>
                    </tr>
                    <tr v-for="(item, vdx) in (group.inputs[0] || {}).value || []" :key="`section-${sdx}-}group-${gdx}-matrix-${vdx}`">
                      <td>{{ item.label }}</td>
                      <td><span :class="{ radio: true, checked: isActiveAdvancedMatrixValue((item.value || [])[0], 1) }" /></td>
                      <td><span :class="{ radio: true, checked: isActiveAdvancedMatrixValue((item.value || [])[0], 2) }" /></td>
                      <td><span :class="{ radio: true, checked: isActiveAdvancedMatrixValue((item.value || [])[1], 1) }" /></td>
                      <td><span :class="{ radio: true, checked: isActiveAdvancedMatrixValue((item.value || [])[1], 2) }" /></td>
                      <td><span :class="{ checkbox: true, checked: isActiveAdvancedMatrixValue((item.value || [])[2]) }" /></td>
                    </tr>
                  </table>
                  <div class="comment">
                    {{ (group.inputs[1] || {}).value || '' }}
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="group-title" v-if="(group.export || {}).label || group.label">
                  {{ (group.export || {}).label || group.label }}
                </div>
                <template v-for="(input, idx) in group.inputs">
                  <div
                    v-if="input.type === 'diagnosis'"
                    :key="`section-${sdx}-}group-${gdx}-content-${idx}`"
                    class="diagnosis-content"
                  >
                    <template v-if="input.value">
                      <table>
                        <tr>
                          <td></td>
                          <td>Code/Bezeichnung</td>
                          <td>Fachstelle / Jahr</td>
                        </tr>
                        <tr v-for="(item, vdx) in input.value" :key="`section-${sdx}-}group-${gdx}-diagnosis-${vdx}`">
                          <td>{{ item.diagnosis }}</td>
                          <td>{{ item.dsm }}</td>
                          <td>{{ item.specialist }}</td>
                        </tr>
                      </table>
                    </template>
                    <template v-else>
                      <table>
                        <tr>
                          <td colspan="3">Keine {{ (group.export || {}).label || group.label }}</td>
                        </tr>
                      </table>
                    </template>
                  </div>

                  <div
                    v-else-if="isTextContent(input.type)"
                    :key="`section-${sdx}-}group-${gdx}-content-${idx}`"
                    class="text-content"
                  >
                    <template v-if="input.exportStyle === 'fullwidth-labeled'">
                      <div class="value fullwidth labeled">
                        <label v-html="parseLabel(input.label, input.export)" />
                        <div v-html="convertLineBreaks(input.value)" />
                      </div>
                    </template>
                    <template v-else-if="input.exportStyle === 'fullwidth'">
                      <div class="value fullwidth" v-html="convertLineBreaks(input.value)" />
                    </template>
                    <template v-else>
                      <div class="label" v-html="parseLabel(input.label, input.export)" />
                      <div class="value" v-html="convertLineBreaks(input.value)" />
                    </template>
                  </div>
                </template>
              </template>
              <div v-if="isPageBreak(`${sdx}-${gdx}`, gdx >= section.groups.length -1)" class="page-break" :key="`pagebreak-${sdx}-group-${gdx}`" />
            </div>
          </template>
        </div>
      </template>
      <div class="section signatures" v-if="signatures">
        <div v-for="(sig, sdx) in signatures" :key="`signature-${sdx}`" v-html="sig" />
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { Store } from '@/store';
  import html2pdf from 'html2pdf.js';
  import InquiryConstants from '@/components/inquiry/InquiryConstants';

  export default {
    name: 'InquiryExportPDF',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      id: {
        type: String,
        default: 'unbekannt',
      },
      exportData: {
        type: Array,
        default: () => [],
      },
      secondarySignature: {
        type: Array,
        default: null,
      },
      frontpage: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        isSmallFrontpage: false,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      signatures() {
        const signatures = [];
        const primary = Store.extras?.signature || null;
        const secondary = this.secondarySignature || null;
        if (secondary) {
          signatures.push(secondary);
        }
        if (primary) {
          signatures.push(primary);
        }
        if (signatures.length > 0) {
          let output = [];
          for (let i = 0, n = signatures.length; i < n; i += 1) {
            const ops = signatures[i];
            let out = '';
            for (let o = 0, m = ops.length; o < m; o += 1) {
              const op = ops[o];
              if (op.insert?.image) {
                out += `<img src="${op.insert.image}" alt=""/>`
              }
              else {
                let text = (op.insert || '').replace(/\n/g, '<br/>');
                const attributes = op.attributes || {};
                if (attributes.italic) {
                  text = `<em>${text}</em>`;
                }
                if (attributes.bold) {
                  text = `<strong>${text}</strong>`;
                }
                out += text;
              }
            }
            if (out !== '') {
              output.push(out);
            }
          }
          if (output.length > 0) {
            return output;
          }
        }
        return null;
      },
      exportDate() {
        const date = new Date();
        const day = `${date.getDate()}`.padStart(2, '0');
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        return `${day}.${month}.${date.getFullYear()}`;
      },
      computedData() {
        let data = this.exportData;
        if (data) {
          data = JSON.parse(JSON.stringify(data));
          const index = this.isSmallFrontpage ? 2 : 1;
          data.splice(index, 0, {
            type: 'privacy',
            imgData: InquiryConstants.PRIVACY_NOTICE,
          });
          return data;
        }
        return [];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      if (this.frontpage) {
        const img = new Image();
        img.onload = () => {
          this.isSmallFrontpage = (img.naturalHeight < 500) || false;
          setTimeout(() => {
            this.export();
          }, 500);
        }
        img.src = this.frontpage;
      } else {
        setTimeout(() => {
          this.export();
        }, 500);
      }
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      export() {
        const filename = this.getFilename(this.exportData, this.id, 'pdf');
        const opt = {
          margin: [20, 20],
          filename,
          image: { type: 'jpeg', quality: 0.94 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait', hotfixes: ['px_scaling'] },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'], before: '.page-break' },
        };

        html2pdf().from(this.$refs.exportable).set(opt).toPdf().get('pdf').then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i += 1) {
            pdf.setPage(i);
            pdf.setFontSize(8);
            pdf.setTextColor(150);
            pdf.text(`${i}/${totalPages}`, pdf.internal.pageSize.getWidth() - 40, pdf.internal.pageSize.getHeight() - 20);
          }
        }).save();

        this.$nextTick(() => {
          this.$el.parentNode.removeChild(this.$el);
          this.$emit('done');
          this.$destroy();
        });
      },

      //----------------------------------
      // Helper Methods
      //----------------------------------
      getFilename(exportData, inquiryid, file_ext) {
        const findObjectById = targetId => exportData.flatMap(obj => obj.groups || [])
          .flatMap(group => group.inputs || [])
          .find(input => input.id === targetId);

        let firstname = findObjectById('9490f6ea-220b-4d71-86b5-b6129887d008');
        firstname = (firstname) ? `${firstname.value} ` : '';
        const lastname = findObjectById('973834ac-3158-46be-8285-820d6545ac99');
        const fullname = (lastname) ? `${firstname}${lastname.value} - ` : '';

        return `SAV Bericht - ${fullname}${inquiryid}.${file_ext}`;
      },
      parseLabel(value, exportData) {
        let label = value;
        if (exportData) {
          label = exportData.pdf || exportData.default;
        }
        return label;
      },
      getAssessmentValue(value, fallback = null) {
        const variants = ['Indikation gegeben', 'Indikation nicht gegeben'];
        if (variants.includes(value)) {
          const index = variants.findIndex(v => v === value);
          if (index === 0) {
            return '<span class="radio checked"></span> Indikation gegeben<br/><span class="radio"></span> Indikation nicht gegeben';
          }
          return '<span class="radio"></span> Indikation gegeben<br/><span class="radio checked"></span> Indikation nicht gegeben';
        }

        if (fallback !== null && fallback === false) {
          return '<span class="radio"></span> Indikation gegeben<br/><span class="radio"></span> Indikation nicht gegeben';
        }
        return '(kein Indikationsbereich)';
      },
      isActiveMatrixValue(expected, received) {
        return expected === received;
      },
      isActiveAdvancedMatrixValue(value, position = null) {
        if (!position) {
          return value !== undefined && value !== null;
        }
        return value === position;
      },
      isTextContent(type) {
        return [
          'textinput',
          'textarea',
          'select',
          'checkbox-group',
          'radio-group',
          'datepicker',
        ].includes(type);
      },
      convertLineBreaks(value) {
        return (value || '').replace(/\n/g, '<br/>');
      },

      isPageBreak(position) {
        const pagebreaks = ['3-0', '4-1', '5-2', '6-2', '6-5', '6-7', '8-0', '9-2'];
        return pagebreaks.includes(position);
      },
      isFirstOfPage(position) {
        const firsts = ['0-0', '2-0', '4-0', '5-0', '6-0', '7-0', '9-0', '10-0'];
        return firsts.includes(position);
      },
      showTitle(position) {
        const titles = ['6-3', '6-6'];
        return /\d+-0/.test(position) || titles.includes(position);
      },
      showICFLegend(position) {
        const icfs = ['6-0', '6-3', '6-6'];
        return icfs.includes(position);
      }
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

$bgcolor-titles: #c6d9f1;
$bgcolor-labels: #dbe5f1;
$bgcolor-values: #f6f6ff;

#document-export-container {
  position: absolute;
  left: -774px;
  width: 750px;
  // left: 20px;

  /*
    Available Document Space
    -------------------------
    Width: 750px
    Height: 1060px
   */
}

.pdf-export {
  margin: 0 auto;
  width: 750px;
  font-family: 'Arial', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.25;

  .frontpage {
    width: 750px;
    // height: 710px;
    height: auto;

    & > img {
      width: 100%;
      height: auto;
    }

    & > div.placeholder {
      position: relative;
      display: block;
      width: 750px;
      height: 710px;
      border: 1px solid black;
      background: red;
    }
  }

  .reportTitle {
    padding-top: 30px;
    padding-bottom: 10px;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    font-size: 20px;
    color: black;
  }

  .section {
    padding-top: 2px;
    width: 100%;
    margin-top: 30px;

    &.first {
      margin-top: 0;
    }

    .privacy {
      width: 100%;
      height: auto;

      &.pad {
        padding-top: 8px;
      }
    }

    &.notes {
      padding: 8px 10px;
      // border: 1px solid black;
      color: black;
    }
    &.signatures {
      padding-right: 32px;
      display: flex;
      justify-content: flex-end;
      color: black;
      gap: 48px;

      & > div {
        & > img {
          display: inline-block;
          width: auto;
          height: 60px;
        }
      }

    }

    .group {
      position: relative;
      padding-top: 2px;
      width: 100%;

      &.first {
        padding-top: 0;
      }

      & > span {
        position: absolute;
        right: 0;
        top: 0;
      }

      .section-title {
        width: 100%;
        padding: 8px 10px;
        margin-bottom: 8px;
        margin-top: 3px;
        background-color: $bgcolor-titles;
        color: black;
        font-size: 15px;
        font-weight: bold;
      }

      .group-title {
        width: 100%;
        padding: 28px 10px 8px 10px;
        color: black;
        font-weight: bold;
      }

      .icf-content {
        width: 100%;

        .legend {
          width: 100%;
          text-align: center;
          padding: 4px 0 16px 0;
          font-size: 12px;
        }

        .content {
          display: flex;

          .left {
            padding: 8px 10px;
            width: 35%;
            background-color: $bgcolor-labels;
            color: black;

            strong {
              display: block;
              margin-bottom: 8px;
            }

            .assessment {
              width: 100%;

              .radio {
                position: relative;
                top: 3px;
                display: inline-block;
                border-radius: 100%;
                width: 12px;
                height: 12px;
                margin-right: 4px;
                border: 0.5px solid;

                &.checked {
                  background: black;
                }
              }
            }
          }
          .right {
            padding: 8px 10px;
            width: 65%;
            margin-left: 4px;
            color: black;

            table {
              width: 100%;
              tr {
                &:first-of-type td {
                  padding-bottom: 4px;
                }
                td {
                  width: 10%;
                  text-align: center;

                  .radio {
                    display: inline-block;
                    border-radius: 100%;
                    width: 12px;
                    height: 12px;
                    border: 0.5px solid;

                    &.checked {
                      background: black;
                    }
                  }

                  &:first-child {
                    width: 60%;
                    text-align: left;
                  }
                }
              }
            }
          }
        }

        .comment {
          margin-top: 4px;
          width: 100%;
          padding: 8px 10px;
          color: black;
          background-color: $bgcolor-values;
        }
      }

      .matrix-advanced-content {
        width: 100%;
        table {
          border: 0;
          border-bottom: 4px solid transparent;
          border-collapse: collapse;
          width: 100%;
          tr {
            td {
              padding: 8px 10px;
              width: 13%;
              color: black;
              text-align: center;

              &:nth-child(1) {
                width: 35%;
                background-color: $bgcolor-labels;
                color: black;
                text-align: left;
              }

              .radio {
                display: inline-block;
                border-radius: 100%;
                width: 12px;
                height: 12px;
                border: 0.5px solid;

                &.checked {
                  background: black;
                }
              }

              .checkbox {
                display: inline-block;
                width: 12px;
                height: 12px;
                border: 0.5px solid;

                &.checked {
                  background: black;
                }
              }
            }

            &:first-child {
              td {
                font-weight: bold;
                vertical-align: top;
              }
            }
          }
        }

        .comment {
          margin-top: 4px;
          width: 100%;
          padding: 8px 10px;
          color: black;
          background-color: $bgcolor-values;
        }
      }

      .diagnosis-content {
        width: 100%;
        table {
          border: 0;
          border-bottom: 4px solid transparent;
          border-collapse: collapse;
          width: 100%;
          tr {
            &:first-of-type {
              td {
                color: initial;
                padding-top: 0;

                &:nth-child(1) {
                  background-color: transparent;
                }
              }
            }
            td {
              padding: 8px 10px;
              width: auto;
              color: black;

              &:nth-child(1) {
                width: 35%;
                background-color: $bgcolor-labels;
                color: black;
              }

              &:nth-child(2) {
                width: 32.5%;
              }
              &:nth-child(3) {
                width: 32.5%;
              }
            }
          }

          &.simplified {
            tr {
              td {
                &:first-child {
                  width: 35%;
                }
                &:last-child {
                  width: 65%;
                }
              }
            }
          }
        }
      }

      .text-content {
        margin: 0;
        display: flex;
        .label {
          padding: 8px 10px;
          min-width: 35%;
          width: 35%;
          background-color: $bgcolor-labels;
          color: black;
        }
        .value {
          padding: 8px 10px;
          width: 65%;
          margin-left: 4px;
          color: black;
          background-color: $bgcolor-values;

          &.fullwidth {
            min-width: 100%;
            margin-left: 0;
            &.labeled {
              background-color: transparent;
              padding: 8px 0;

              & > label {
                display: block;
                width: 100%;
                padding: 14px 10px 8px 8px;
                color: black;
                font-weight: bold;
              }
              & > div {
                padding: 8px 10px;
                background-color: $bgcolor-values;
              }
            }
          }
        }
      }
    }
  }
  .section, .group, .text-content, .icf-content, .matrix-advanced-content, .diagnosis-content {
    page-break-inside: avoid !important;
  }

  .page-break {
    page-break-before: always;
  }

  @media print {
    .avoid-page-break {
      break-inside: avoid;
    }
  }
}
</style>
